import classNames from 'classnames';

import { Location, Calls, Email, Net } from '@/icons/index';

import SectionTitle from '../SectionTitle/SectionTitle';
import CircleIcon from '../CircleIcon/CircleIcon';
import styles from './AddressCards.module.scss';

const AddressCards = ({ data, className }) => {
  const renderPhoneLinks = (item, index) => {
    return (
      <a
        className={styles['address-card__link']}
        href={`tel:${item?.text}`}
        key={index}
        itemScope
        itemType='https://schema.org/Organization'
      >
        <Calls className={styles['address-card__link-icon']} />
        {item?.text}
      </a>
    );
  };

  const renderEmailLinks = (item, index) => {
    return (
      <a
        className={styles['address-card__link']}
        href={`mailto:${item?.text}`}
        key={index}
        itemScope
        itemType='https://schema.org/Organization'
      >
        <Email className={styles['address-card__link-icon']} />
        {item?.text}
      </a>
    );
  };

  const renderNetLinks = (item, index) => {
    return (
      <a
        className={styles['address-card__link']}
        href={item?.text}
        target='_blank'
        rel='noreferrer'
        key={index}
        itemScope
        itemType='https://schema.org/Organization'
      >
        <Net className={styles['address-card__link-icon']} />
        {item?.text}
      </a>
    );
  };

  const renderAddressItem = (item, index) => {
    return (
      <acticle
        className={styles['address-card']}
        key={index}
        itemScope
        itemType='https://schema.org/Organization'
      >
        <div className={styles['address-card__content']}>
          {item?.icon && (
            <CircleIcon
              className={styles['address-card__icon']}
              path={item?.icon}
              alt={'icon'}
            />
          )}
          {item?.title && (
            <SectionTitle
              titleModify={classNames(
                styles['address-card__title'],
                'title--medium',
              )}
            >
              {item?.title}
            </SectionTitle>
          )}
          {!!item.addresses && (
            <div
              className={styles['address-card__path']}
              itemScope
              itemType='https://schema.org/PostalAddress'
            >
              <Location className={styles['address-card__path-icon']} />
              {item.addresses.map((item) => (
                <span className={styles['address-card__path-text']} key={''}>
                  {item?.text}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className={styles['address-card__links']}>
          {item?.phones && (
            <div className={styles['address-card__row']}>
              {item.phones.map(renderPhoneLinks)}
            </div>
          )}
          {item?.emails && (
            <div className={styles['address-card__row']}>
              {item.emails.map(renderEmailLinks)}
            </div>
          )}
          {item?.sites && (
            <div className={styles['address-card__row']}>
              {item.sites.map(renderNetLinks)}
            </div>
          )}
        </div>
      </acticle>
    );
  };

  return (
    <section
      className={classNames(styles['address-cards'], className)}
      itemScope
      itemType='https://schema.org/Organization'
    >
      {data?.title && (
        <SectionTitle
          className={classNames(styles['address-cards__title'], 'title--large')}
          icon={data?.icon}
        >
          {data?.title}
        </SectionTitle>
      )}
      {data?.cards && (
        <div className={styles['address-cards__inner']}>
          {data?.cards?.map(renderAddressItem)}
        </div>
      )}
    </section>
  );
};

export default AddressCards;
